import { type Height } from '@atlassian/company-hub-common';

import { CardsLayout } from '../../../../../types';

import { cardsDimensionsV1, cardsDimensionsV2 } from './constants';

/**
 * Card dimensions for cards 1.0 and 2.0
 *
 * - The max number of cards per row determines the min width of different card sizes
 * - The max width is used in case the first row is not full
 */

type getCardComponentProps = {
	cardSize: Height;
	isCardsV2Enabled?: boolean;
	layout?: CardsLayout;
};

export const getCardDimensions = ({
	cardSize,
	layout,
	isCardsV2Enabled,
}: getCardComponentProps) => {
	if (isCardsV2Enabled && layout === CardsLayout.FIXED_IMAGE_HEIGHT) {
		return cardsDimensionsV2[cardSize];
	}

	if (layout === CardsLayout.FLEXIBLE_IMAGE_HEIGHT) {
		return cardsDimensionsV1[cardSize];
	}

	return cardsDimensionsV1[cardSize];
};
